import api from "../utils/api-axios";

export const profileApi = {
  getUserProfile: async (userId) => {
    return api.get(`/user/${userId}`);
  },

  getUserListings: async (userId) => {
    return api.get(`/listing/user/${userId}`);
  },

  getSavedListings: async () => {
    return api.get("/user/saved-listings");
  },

  getUserExchanges: async () => {
    return api.get("/exchange/user");
  },

  /**
   * Set the user's location from precise coordinates (browser geolocation
   * or a map pin). Backend reverse-geocodes to fill in label and addressParts.
   *
   * @param {[number, number]} coordinates [lng, lat]
   * @param {"gps"|"manual_pin"} precision how the coords were obtained
   */
  setLocationFromCoords: async (coordinates, precision = "gps") => {
    return api.put("/user/update", {
      location: { coordinates, precision },
    });
  },

  /**
   * Set the user's location from a text search.
   * Used when the user picks one of the autocomplete suggestions.
   *
   * @param {string} searchQuery     what the user picked
   * @param {string} countryCode     ISO 2-letter (e.g. "ZA") to bias results
   */
  setLocationFromSearch: async (searchQuery, countryCode = "ZA") => {
    return api.put("/user/update", {
      location: { searchQuery, countryCode },
    });
  },

  /**
   * Set the user's location from a fully-resolved suggestion (skips a backend
   * geocode round-trip — we already have the coordinates and label from the
   * autocomplete response).
   */
  setLocationFromSuggestion: async (suggestion) => {
    return api.put("/user/update", {
      location: {
        coordinates: suggestion.coordinates,
        precision: "geocoded",
      },
    });
  },

  /**
   * Clear the user's saved location.
   */
  clearLocation: async () => {
    return api.put("/user/update", { location: null });
  },
};